import { Progress as Progress_ } from "@chakra-ui/react"
export const Progress = ({ ...props }) => {
    return <Progress_ {...props}>{props?.children}</Progress_>
}

import { ProgressLabel as ProgressLabel_ } from "@chakra-ui/react"
export const ProgressLabel = ({ ...props }) => {
    return <ProgressLabel_ {...props}>{props?.children}</ProgressLabel_>
}